import { RoutalButton, RoutalButtonProps, RoutalLoader, RoutalPalette } from '@nx-smartmonkey/ui';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';

export const OnboardingNextStepButton = (
  props: React.PropsWithChildren<RoutalButtonProps> &
    React.HTMLAttributes<RoutalButtonProps> &
    React.ButtonHTMLAttributes<RoutalButtonProps>
) => {
  const intl = useIntl();
  const { onClick, children, ...otherProps } = props;
  const [nextStepAnimation, setNextStepAnimation] = useState<boolean>(false);

  const handleClick = (e: any) => {
    setNextStepAnimation(true);
    if (onClick) onClick(e);
  };

  return (
    <RoutalButton {...otherProps} disabled={nextStepAnimation} onClick={handleClick}>
      {nextStepAnimation ? (
        <RoutalLoader color={RoutalPalette.oldWhite} width={18} />
      ) : (
        intl.formatMessage({ id: `company.onboarding.next` })
      )}
    </RoutalButton>
  );
};
